export default "__VITE_ASSET__DReabwwC__"